import React from "react";
import Navbar from "../../components/Navbar";
import Container from "../../components/Container";
function index() {
  return (
    <>
      <Container />
    </>
  );
}

export default index;
